import { Component, OnInit, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import {
    IonicPage, NavController, NavParams, AlertController, ModalController, LoadingController, Loading,
    ToastController, ViewController, PopoverController, Content, Platform, Events
} from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { Page } from '../../enums/page.enum';

/* Models */
import { CustomerModel } from '../../models/customer/customer.model';
import { ProductModel } from '../../models/product/product.model';
import { OrderHeaderModel } from '../../models/order/orderheader.model';
import { OrderDetailModel } from '../../models/order/orderdetail.model';
import { OrderModel } from '../../models/order/order.model';
import { Errors } from '../../services/apperror';
import { OrderHighLevelModel } from '../../models/order/orderhighlevel.model';

import { PRDCHANGEDModel } from '../../models/order/prdchanged.model';
/* Pages & Popovers */
// import { OrderReview } from '../order-review/order-review';
// import { StockLevel } from '../stock-level/stock-level';
// import { ConditionType } from '../condition-type/condition-type';
// import { OrderListPopover } from '../popover/order-list-popover/order-list-popover';
/* Filters & Services */
import { NumFormatter } from '../../filters/num-formatter.pipe';
import { TransactionService } from '../../services/transaction.service';
import { BadgeService } from '../../services/badge.service';
import { UtilService } from '../../services/util.service';
import { StorageService } from '../../services/storage.service';
import { Setups } from '../../services/setup';

/* lodash */
import * as _ from "lodash";
import { CustomerService } from '../../services/customer.service';
import { ProductType } from '../../enums/producttype.enum';
import { SettingId } from '../../enums/settingid.enum';
import { SalesInd } from '../../enums/salesind.enum';
import { AuthWrapper } from '../../infra/authWrapper';
import { QuoteStatus } from '../../enums/quotestatus.enum';
import { CustomerMOVSurchargeModel } from '../../models/customer/customerMOVSurcharge.model';
import { UserService } from '../../services/user.service';
import { ModalAction } from '../../enums/modalaction.enum';

@IonicPage()
@Component({
    selector: 'order-list',
    templateUrl: 'order-list.html',
    providers: [NumFormatter]
})
export class OrderList implements OnInit {
    @ViewChild('foot') elementView: ElementRef;
    @ViewChild(Content) content: Content;
    productList: ProductModel[];
    loading: Loading;
    bottomPixel: string;
    direction: string;
    showScrollToTop: Boolean = false;
    showList: Boolean = false;
    isPrdNameChanged: boolean = false;
    selectedCustomer: CustomerModel;
    highLevelList: OrderHighLevelModel[] = [];
    highLevel: OrderHighLevelModel = <OrderHighLevelModel>{};

    subTotal: number = 0;
    totalQty: number = 0;
    orderTitle: string = "Order";
    order: OrderHeaderModel = <OrderHeaderModel>{};
    //SAPorderdetail: OrderDetailModel[];
    isModal: Boolean = false;
    _timeout: any = null;
    hideCustomerDetail: Boolean = true;

      
    PrdChanged_list:PRDCHANGEDModel[];
    displayAdvanceFOC: boolean = false;
    isVN: Boolean = false;
    isShowingBaseUOM: boolean = false;
    isHandlingFOC: boolean = false;
    hasOrderListError: boolean = false;

    public ProductTypeEnum = ProductType;
    public SalesIndEnum = SalesInd;
    // CCLIORDER-2818
    isShowingMOV: boolean = false;
    customerMOVSurcharge: CustomerMOVSurchargeModel = new CustomerMOVSurchargeModel;
    // CCLIORDER-2818
    
    constructor(
        private storage: Storage,
        public navCtrl: NavController,
        public navParams: NavParams,
        public modalCtrl: ModalController,
        public toastCtrl: ToastController,
        private badgeService: BadgeService,
        private transactionService: TransactionService,
        public storageService: StorageService,
        public util: UtilService,
        private loadingCtrl: LoadingController,
        private viewCtrl: ViewController,
        public popoverCtrl: PopoverController,
        private events: Events,
        private platform: Platform,
        private changeDetectorRef: ChangeDetectorRef,
        private alertCtrl: AlertController
        , public setups: Setups
        , private customerService: CustomerService
        , private userService: UserService
        , private authWrapper: AuthWrapper
    ) {
            this.isVN = window.location.hostname.indexOf('easyorder.vnbizbox.com') != -1;
            this.isShowingBaseUOM = this.storageService.getSetupValue(this.setups.ShowBaseUOM.ID) === "1" ? true : false;
    }

    async ionViewWillEnter() {
        this.storage.get('quoteRevision').then((quoteStatus)=>{
         if(quoteStatus){
             this.storage.set('quoteRevision', false)
         }
        });

        this.showList = false;
        this.hasOrderListError = false;
        let submitted = await this.storage.get('submitted');
        if (submitted) {
            this.order = <OrderHeaderModel>{};
            this.storage.remove('submitted')
            this.storageService.clearOrder();
            return;
        }

        // CCLIORDER-2818
        if (this.userService.isHKSurchargeApplicable()) {
            this.isShowingMOV = this.userService.isHKSurchargeApplicable();
            this.customerService.getCustomerMOVSurcharge(this.storageService.getCustomer().salesorg.salesorg, this.storageService.getSettingId()).subscribe(
                (res) => {
                    this.customerMOVSurcharge = res.data;
                }, (error) => {
                    const errObj = JSON.parse(error._body)
                    // display error
                    this.util.displayAlert(this.alertCtrl, "Error", errObj.message);
                }
            );
        }

        this.storageService.setFromSession().then(() => {
            this.isModal = (this.navParams.data.isModal ? true : false);
            if (!this.isModal) {
              this.order = this.storageService.getOrder();
            } else {
              this.order = this.navParams.data.order;
            }

            if (!this.isModal) {
                this.selectedCustomer = this.storageService.getCustomer();
                if (_.isEmpty(this.selectedCustomer)) {
                    this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.CustomerNotSelected.Code, Errors.CustomerNotSelected.Message, Page.CustomerList);
                    return;
                }

                let orderValid: Boolean = true;
                if (!this.order) { orderValid = false; }
                else if (_.isEmpty(this.order)) { orderValid = false; }
                else if (this.order.detail.length == 0) { orderValid = false; }

                if (!orderValid) {
                    this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.OrderNoItemFound.Code, Errors.OrderNoItemFound.Message, Page.CustomerList);
                    this.storageService.clearCustomer(); //[TIC0942234]- Unable to proceed to select payer after changing salesorg
                    this.badgeService.resetBadge();
                    return;
                } else if (this.order.sales_ind !== this.storageService.getSalesInd()) {
                  if (this.order.txn_status == QuoteStatus.QuoteDraft || this.order.txn_status == QuoteStatus.QuotePending || this.order.txn_status == QuoteStatus.QuoteApproved || this.order.txn_status == QuoteStatus.QuoteReject) {
                    this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.OrderNoItemFound.Code, Errors.OrderNoItemFound.Message, Page.CustomerList);
                    this.badgeService.resetBadge();
                  }
                  else {
                    this.displayOrderTypeConflictMsg(this.storageService.getSalesIndFromOrder(this.order));
                  }                  
                    
                } else {
                    Promise.all([
                        this.storageService.getOrder()
                        , this.storageService.getSimulatedOrder()
                    ]).then(([order, simulatedOrder]) => {
                        const hasSimulatedOrder = (simulatedOrder != null && typeof simulatedOrder === 'object' && Object.keys(simulatedOrder).length > 0);
                        if (hasSimulatedOrder === false) {
                            this.isHandlingFOC = true;
                            this.updateOrderList();
                        } else {
                            if (JSON.stringify(order) !== JSON.stringify(simulatedOrder)) {
                                this.isHandlingFOC = true;
                                this.updateOrderList();
                            } else {
                                if (order.et_foc != null && order.et_foc.length !== 0 && order.et_foc[0].uepos !== "") {
                                    this.displayAdvanceFOC = true;
                                }
                            }
                        }

                        this.getTotal();
                        this.orderTitle = this.storageService.getOrderTypeTitle(this.storageService.getSalesIndFromOrder(this.order));
                        this.showList = true;
                    });
                }
            } else {
                this.getTotal();
                this.orderTitle = this.storageService.getOrderTypeTitle(this.storageService.getSalesIndFromOrder(this.order));
                this.showList = true;
            }
        });
    }

    getTotal() {
        this.arrangeLineItem();        
        if (this.storageService.getSalesIndFromOrder(this.order)) {            
            this.subTotal = 0;
            this.order.detail.forEach((item) => {
                if (item.line_type.sales_ind == 1) {                   
                    this.subTotal += item.ttl_net_amt;
                }
                
                // BOM
                item.bom_item.forEach((r) => {
                    this.subTotal += r.ttl_net_amt;
                })


                item.isprd_name_change= false;

                // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
                if(this.storageService.getSettingId() === "1007") {
                    var ctZWSO = []
                    if (Array.isArray(item.cond_type) && item.cond_type.length > 0) {
                        ctZWSO = item.cond_type.filter((ct) => {
                            return ct.disc_cond == "ZWS0";
                        });

                        if (ctZWSO.length > 0) {
                            // item.gross_amt = this.isModal? (ctZWSO[0].disc_amount / item.quantity) : (ctZWSO[0].disc_value / item.quantity);
                            // item.gross_amt = Number(item.gross_amt.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]);
                            item.gross_amt = this.isModal ? Number(ctZWSO[0].disc_amount) : Number(ctZWSO[0].disc_amount) / 1000;
                        }
                    } 
                }
            });
        }

        this.totalQty = 0;
        this.totalQty += this.order.detail.length;
        this.order.detail.forEach((item) => {
            if (item.foc_item.length > 0) {
                if (item.foc_del_ind == 0) {
                    this.totalQty += item.foc_item.length;
                }
            }

            // BOM
            for (let index = 0; index < item.bom_item.length; index++) {
                this.totalQty += item.bom_item[index].quantity;
                item.bom_item[index].so_item = '-';
            }
        });
    }

    openProductDescriptionModal(item: OrderModel, J: string){
        this.transactionService.retrieveProductChangedDetails(this.storageService.getSettingId(),this.order.txn_no, item.prd_code).subscribe(
            (data) => {
                this.PrdChanged_list= data;
                let PrdUpdateModal = this.modalCtrl.create('UpdateProductDescription',
                { orderdetail: item, PrdChangedList: this.PrdChanged_list[0] },{ enableBackdropDismiss: false });
                PrdUpdateModal.present();
                PrdUpdateModal.onDidDismiss(async (data) => {              
                    if (!!data) {
                        if (!!data.action) {
                            switch (data.action) {
                                case 'cancel':
                                    return false;
                                case 'same-customer':
                                    this.order.detail[J].is_prd_name_changed= true;
                                    await this.storage.set('order', this.order);
                                    this.storageService.setOrder(this.order);
                                    return;
                            }
                        }                  
                    }
                });
            },
            (err) => {
                this.util.processError(this.loading, this.alertCtrl, err);
            }, () => {
            }
        )
    }

    getProductChangeDetails(txn_no:string, prd_code:string){
        this.transactionService.retrieveProductChangedDetails(this.storageService.getSettingId(),txn_no, prd_code).subscribe(
            (data) => {
                this.PrdChanged_list= data;
            },
            (err) => {
                this.util.processError(this.loading, this.alertCtrl, err);
            }, () => {
            }
        )
    }

    arrangeLineItem() {
        let lineNo = 1;
        this.order.detail.forEach((item) => {
            if (item.so_item) {
                if (item.line_type.sales_ind == 1) {
                    let s = this.order.detail.find((r) => { return r.high_level.so_item == item.so_item && r.line_type.sales_ind == 0 });
                    if (s) {
                        if (s.high_level.prd_code == item.prd_code)
                            s.high_level.so_item = lineNo.toString();
                        //else 
                        //   s.high_level.so_item = s.high_level.so_item;
                    }
                }
            }

            item.so_item = lineNo.toString();
            lineNo++;
            if (item.foc_item.length > 0) {
                item.foc_item.forEach((foc) => {
                    if (foc.foc_del_ind == 0) {
                        foc.so_item = lineNo.toString();
                        lineNo++;
                    }
                    else {
                        foc.so_item = "-";
                    }
                })
            }
        });
    }

    updateHighLevel(soItem: string) {

        let r = this.order.detail.filter((r) => { return r.high_level.so_item == soItem && r.line_type.sales_ind == 0 });
        if (r) {
            r.forEach((item) => {
                let n = this.order.detail.filter((i) => { return i.so_item < item.so_item && i.line_type.sales_ind == 1 });
                if (n) {
                    let newHighLevel = new OrderHighLevelModel();
                    newHighLevel.prd_code = n[n.length - 1].prd_code;
                    newHighLevel.prd_name = n[n.length - 1].prd_name;
                    newHighLevel.so_item = n[n.length - 1].so_item;
                    item.high_level = newHighLevel;
                }
            });
        }
    }

    private navigateToOrderReview() {
        // CCLIORDER-1555 price become zero
        this.storageService.setSimulatedOrder(this.order).then(() => {
            this.navCtrl.push('OrderReview');
        });
    }

    private checkOrderSimulatedBeforeNavigate() {
        Promise.all([
            this.storageService.getOrder()
            , this.storageService.getSimulatedOrder()
        ]).then(([order, simulatedOrder]) => {
            const hasSimulatedOrder = (simulatedOrder != null && typeof simulatedOrder === 'object' && Object.keys(simulatedOrder).length > 0);

            if (hasSimulatedOrder === false) {
                let message = "You have modified the items in the order. Refresh to get the latest prices & bonuses before proceeding.";
                let arrButtons = [{
                    text: 'Cancel', handler: () => {}
                },
                {
                    text: 'Refresh', handler: () => {
                        this.isHandlingFOC = true;
                        this.updateOrderList();
                    }
                }];        
                this.util.displayConfirmation(this.alertCtrl, "Refresh Required", message, arrButtons);
            } else {
                if (JSON.stringify(order) !== JSON.stringify(simulatedOrder)) {
                    let message = "You have modified the items in the order. Refresh to get the latest prices & bonuses before proceeding.";
                    let arrButtons = [{
                        text: 'Cancel', handler: () => {}
                    },
                    {
                        text: 'Refresh', handler: () => {
                            this.isHandlingFOC = true;
                            this.updateOrderList();
                        }
                    }];        
                    this.util.displayConfirmation(this.alertCtrl, "Refresh Required", message, arrButtons);
                } else {
                    this.navigateToOrderReview();
                }
            }
        });
    }

    updateOrderList() {
        if (!this.util.checkTxnStatus(this.order.txn_status)) {
            return;
        }

        if (this.storageService.getSalesIndFromOrder(this.order) === SalesInd.FOC) {
            return;
        }

        if (this.order.detail.findIndex((r) => { return (r.quantity == 0 || r.quantity == null || r.quantity.toString() == "") && r.line_type.sales_ind == 1; }) > -1) {
            this.util.displayAlert(this.alertCtrl, "Quantity zero not allowed", "One or more of your items have 0 or empty quantity!");
            return;
        }
       
        this.hasOrderListError = true;
        this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Preparing request data");
        this.transactionService.retrieveOrderList(this.order, this.storageService.getSettingId()).subscribe(
            (data) => {
                if (data) {
                    let itemsInOrderListPage = this.storageService.getitemsInOrderListPage();
                    if (typeof data == "string") {
                        this.markOrderListError();
                        // Custom errors raised from DB, not from SAP
                        const isCustomDbError = data.startsWith("There's no storage plant mapped for product")
                            || data.startsWith("There's no storage location mapped for product");
                        this.util.displayAlert(this.alertCtrl, isCustomDbError ? "Error" : "SAP Error", data);
                        this.util.checkHideFooter(this.order.detail.length, this.order.detail.length <= itemsInOrderListPage ? 'down' : this.direction); 
                    } else {
                        this.processSAPData(data);
                        this.hasOrderListError = false;
                        this.util.checkHideFooter(data.detail.length, this.order.detail.length <= itemsInOrderListPage ? 'down' : this.direction); 
                    }
                }            
                else {
                    this.markOrderListError();
                    this.util.displayAlert(this.alertCtrl, "SAP data retrieval error",
                        `We're unable to retrieve the final order pricing from SAP right now, please use the 'Refresh' button to try again later. 
                    Item(s) above are displayed with estimated pricing.`);
                }
            },
            () => {
                this.markOrderListError();
                this.loading.dismiss();
                this.util.displayAlert(this.alertCtrl, "SAP data retrieval error",
                    `We're unable to retrieve the final order pricing from SAP right now, please use the 'Refresh' button to try again later. 
                    Item(s) above are displayed with estimated pricing.`);
            }, () => {
                this.loading.dismiss();
            })
    }

    displayOrderTypeConflictMsg(salesInd: string) {
        let message = "You have pending " + this.storageService.getOrderTypeTitle(this.storageService.getSalesIndFromOrder(this.order)) + ". Do you wish to continue? All pending order will be lost.";
        let arrButtons = [{
            text: 'No', handler: () => {
                if (this.storageService.getSalesIndFromOrder(this.order) == 'S' || this.storageService.getSalesIndFromOrder(this.order) == 'C') {
                    this.updateOrderList();
                    this.storageService.setSalesInd(this.storageService.getSalesIndFromOrder(this.order));
                }
            }
        },
        {
            text: 'Yes', handler: () => {
                this.storageService.clearOrder().then(() => {
                    this.createNewOrder();
                    this.resetPageAndRedirect(this.storageService.getSalesInd());
                });
            }
        }];        
        this.util.displayConfirmation(this.alertCtrl, "Pending " + this.storageService.getOrderTypeTitle(this.storageService.getSalesIndFromOrder(this.order)) + " found", message, arrButtons);
    }

    resetPageAndRedirect(salesInd: string) {
        this.badgeService.resetBadge();
        this.showList = false;

        this.storageService.setSalesInd(salesInd);
        this.events.publish('change-tab-params', Page.ProductList, false);
    }

    processSAPData(order: OrderHeaderModel) {
        // TODO: Why only 2 countries?
        // TODO: SPP hard code again instead of mapping. TBL_CFG_COND_TYPE_MAPPING created and not used. Weak design
        // order type determine in SPP 
        if(this.storageService.getSettingId() == "2" || "3"){        
            this.order.ord_type = order.ord_type;
        }

        this.displayAdvanceFOC = false;

        if (order.et_foc == null || (order.et_foc.length === 1 && order.et_foc[0].uepos === "")) {
            this.isHandlingFOC = false;
        }

        this.order.et_foc = (!order.et_foc ? [] : order.et_foc);
        this.order.cond_type = (!order.cond_type ? [] : order.cond_type);
        
        this.order.ttl_gross_amt = order.ttl_gross_amt;
        this.order.ttl_net_amt = order.ttl_net_amt;
        this.order.ttl_tax_amt = order.ttl_tax_amt;
        this.order.ttl_ord_amt = order.ttl_ord_amt;
        // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
        // due to the empty ttlt_disc_amt from the FM, manually populate it
        if (this.storageService.getSettingId() != "1007") {
            this.order.ttl_disc_amt = order.ttl_disc_amt;
        } else {
            this.order.ttl_disc_amt = 0;
        }

        let data = order.detail;
        this.order.detail.forEach((element) => {
            if (element.line_type.sales_ind == 1 || element.line_type.sales_ind == 2) {
                let SAPOrder = data.filter((r) => { return r.prd_code == element.prd_code && r.uom_code == element.uom_code })[0];
                if (SAPOrder) {
                    element.base_uom = SAPOrder.base_uom;
                    element.gross_amt = SAPOrder.gross_amt;
                    element.ttl_net_amt = SAPOrder.ttl_net_amt;
                    element.ttl_gross_amt = SAPOrder.ttl_gross_amt;
                    element.ttl_tax_amt = SAPOrder.ttl_tax_amt;
                    element.quantity = SAPOrder.quantity;
                    element.plant = SAPOrder.plant;
                    element.bonus = SAPOrder.bonus;
                    element.itmtxt = SAPOrder.itmtxt;
                    element.tdid = SAPOrder.tdid;
                    element.item_category = SAPOrder.item_category;
                    element.quantity = SAPOrder.quantity;
                    // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
                    // due to the empty ttlt_disc_amt from the FM, manually populate it
                    //TODO Why only TW dont calculate it?
                    if(this.storageService.getSettingId() === "1007") {
                        // TODO: no use?
                        let disc_value = 0;
                        let ctArray = SAPOrder.cond_type.filter((ct) => {
                            return ct.disc_cond == 'ZWS0' || ct.disc_cond == 'ZWR0' 
                        })

                        if (ctArray.length > 0) {
                            let gross = 0;
                            ctArray.forEach((ct) => {
                                if (ct.disc_cond == 'ZWR0') {
                                    disc_value +=  ct.disc_value - SAPOrder.ttl_gross_amt - SAPOrder.ttl_tax_amt;
                                }

                                if (ct.disc_cond == 'ZWS0') {
                                    gross = ct.disc_value
                                    disc_value +=  ct.disc_value -  SAPOrder.ttl_gross_amt -  SAPOrder.ttl_tax_amt;
                                }
                            });

                            element.ttl_disc_amt =  gross -  SAPOrder.ttl_net_amt -  SAPOrder.ttl_tax_amt;
                            this.order.ttl_disc_amt += element.ttl_disc_amt;
                        }
                    } else {
                        element.ttl_disc_amt = SAPOrder.ttl_disc_amt;
                    }

                    element.foc_item = (SAPOrder.foc_item ? SAPOrder.foc_item : []);
                    element.bom_item = (SAPOrder.bom_item ? SAPOrder.bom_item : []);
                    /**
                     * This one use for bom material only
                     * BOM is a set of material. When you change the quantity of the parent, the children quantity will follow a particular ratio
                     * Ex: Dummy bomb has 3 children and its ratio is 1:3:2
                     * Parent 1: Children 1:3:2
                     * Parent 2: Chidlren 2:6:4
                     */
                    element.bom_item.forEach((e) => {
                        e.quantity_ratio = (e.quantity / SAPOrder.quantity);
                    }); 
                    element.cond_type = (SAPOrder.cond_type ? SAPOrder.cond_type : []);
                    if (element.foc_item) {
                        if (element.foc_item.length > 0) {
                            element.foc_item.forEach((e) => {
                                //e.prd_name = element.prd_name;
                                if(e.prd_name == null) e.prd_name = element.prd_name;
                                else e.prd_name = e.prd_name;
                            })
                        }
                    }
                }
            } else {
                element.foc_item = [];
            }
        });

        this.getTotal();
        this.storageService.setOrder(this.order).then(() => {
            this.storageService.setSimulatedOrder(this.order).then(() => {
                if (order.et_foc !== null) {
                    if (order.et_foc.length != 0 && order.et_foc[0].uepos != "") {
                        this.displayAdvanceFOC = true;
                        if (this.isHandlingFOC) {
                            this.editFOC();
                        }
                    }
                }
            });
        });
    }

    updateBatchNo(batch_no: any, orderDetail: OrderDetailModel){
        if (this._timeout) { //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;

            orderDetail.batch_no = batch_no;
            this.storageService.setOrder(this.order);
        }, 1000);
    }

    // STRY0017241 - Add shipping point as additional field - EPC
    updateShippingPoint(shipping_point: any, orderDetail: OrderDetailModel){
        if (this._timeout) { //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;

            orderDetail.shipping_point = shipping_point;
            this.storageService.setOrder(this.order);
        }, 1000);
    }

    updateQty(ev: any, orderDetail: OrderDetailModel) {
        // E0-3513 - TW_MOV
        if (this.util.isFreightFeeSku(orderDetail.prd_code, this.storageService.getSettingId())) {
            orderDetail.quantity = 1;
            return;
        }
        if (this._timeout) { //if there is already a timeout in process cancel it
            window.clearTimeout(this._timeout);
        }
        this._timeout = window.setTimeout(() => {
            this._timeout = null;

            if (ev == '') {
                orderDetail.quantity = 0;
                orderDetail.default_quantity = 0;
            }
            this.adjustQty(orderDetail, undefined);
        }, 1000);
    }

    adjustQty(p: OrderDetailModel, status: any) {
        this.isHandlingFOC = true;

        // E0-3513 - TW_MOV
        if (this.util.isFreightFeeSku(p.prd_code, this.storageService.getSettingId())) return;

        if (status == 'add') {
            p.quantity++;
            p.ttl_gross_amt = p.gross_amt * p.quantity; //p.ttl_gross_amt += p.gross_amt;
        } else if (status == 'minus') {
            if (p.quantity <= 0) {
                p.quantity = 0
            }
            else {
                p.quantity--;
            }
            p.ttl_gross_amt = p.gross_amt * p.quantity; //p.ttl_gross_amt -= p.gross_amt;
        } else if (status == undefined) {
            p.ttl_gross_amt = p.gross_amt * p.quantity;
        }
        p.ttl_disc_amt = 0;
        p.ttl_net_amt = 0;
        p.ttl_tax_amt = 0;
        let taxPercent: number = 0;
        if (p.cond_type.length > 0) {
            if (this.storageService.getSettingId() === "1007") {
                    if (p.line_type.sales_ind == 1 || p.line_type.sales_ind == 2) {
                        let SAPOrder = _.cloneDeep(p);

                        if (SAPOrder) {
                            //TODO disc_value never used
                            let disc_value = 0;
                            let ctArray = SAPOrder.cond_type.filter((ct) => {
                                return ct.disc_cond == 'ZWS0' || ct.disc_cond == 'ZWR0' 
                            });

                            if (ctArray.length > 0) {
                                let gross = 0;
                                ctArray.forEach((ct) => {
                                    if (ct.disc_cond == 'ZWR0') {
                                        disc_value +=  ct.disc_value - SAPOrder.ttl_gross_amt - SAPOrder.ttl_tax_amt;
                                    }

                                    if (ct.disc_cond == 'ZWS0') {
                                        gross = ct.disc_value
                                        disc_value +=  ct.disc_value -  SAPOrder.ttl_gross_amt -  SAPOrder.ttl_tax_amt;
                                    }
                                });

                                p.ttl_disc_amt = (gross -  SAPOrder.ttl_net_amt -  SAPOrder.ttl_tax_amt)/SAPOrder.quantity*p.quantity;
                                p.ttl_tax_amt = SAPOrder.ttl_tax_amt/SAPOrder.quantity*p.quantity;
                                this.order.ttl_disc_amt += p.ttl_disc_amt;
                            }
                        }
                    } 
            }
            else {
            p.cond_type.forEach((item) => {
                //if (item.disc_cond != 'ZTN7' && item.disc_cond != 'ZTS0' && item.disc_cond != 'ZTS5' && item.disc_cond != 'MWST' && item.disc_cond != 'ZSS0' && item.disc_cond != 'ZSS1' && item.disc_cond != 'ZSS2' && item.disc_cond != 'ZSS3' && item.disc_cond != 'ZMS0' && item.disc_cond != 'ZGS0') {
                if (this.storageService.getConditionTypeList().indexOf(item.disc_cond) == -1 && item.disc_cond != this.storageService.getConditionTypeTax().toString()) {
                    if (item.disc_type_code == '%') {
                        p.ttl_disc_amt += Number(item.plusminus + (p.ttl_gross_amt * Number(item.disc_amount) / 100));
                        //1430 
                    } else {
                        p.ttl_disc_amt += Number(item.plusminus + (Number(item.disc_amount) * p.quantity)); //p.ttl_disc_amt += Number(item.plusminus + Number(item.disc_amount));
                    }
                //} else if (item.disc_cond == 'MWST') {
                } else if (item.disc_cond == this.storageService.getConditionTypeTax().toString()) {
                    taxPercent = Number(item.disc_amount);
                    // p.ttl_tax_amt += p.ttl_gross_amt * Number(item.disc_amount) / 100;
                }
            });
        }
        }
        
        if (this.storageService.getSettingId() === "1007") {
            p.ttl_net_amt = p.ttl_gross_amt - p.ttl_disc_amt - p.ttl_tax_amt;
        }
        else {
            p.ttl_net_amt = p.ttl_gross_amt + p.ttl_disc_amt;
            if (taxPercent > 0)
                p.ttl_tax_amt = p.ttl_net_amt * (Number(taxPercent) / 100);
        }
        this.storageService.setOrder(this.order).then(() => {
            this.getTotal();
        });
        p.default_quantity = p.quantity;
    }

    cancel() {
        this.viewCtrl.dismiss();
    }

    checkPrice(item: any) {
        if(this.storageService.getSettingId() == "1007" && item.gross_amt == 0 && item.line_type?.ind == "S") return true;
        return false;
    }

    toggleCustomerDetail() {
        this.hideCustomerDetail = !this.hideCustomerDetail;
    }

    ngOnInit() {
        if (!this.authWrapper.isAuthenticated()) {
            this.authWrapper.unAuthenticatedRedirect();
            return;
        }

        if (this.platform.is('mobile') == true) {
            this.bottomPixel = (80 + this.elementView.nativeElement.offsetHeight) + 'px';
        } else {
            this.bottomPixel = (15 + this.elementView.nativeElement.offsetHeight) + 'px';
        }

        this.content.ionScrollEnd.subscribe((data) => {
            if(data == null){
                this.showScrollToTop = false;
            }
            else{
                let itemsInOrderListPage = this.storageService.getitemsInOrderListPage();
                if (data['scrollTop'] > 0) { this.showScrollToTop = true; }
                else { this.showScrollToTop = false; }
                if(this.order.detail.length <= itemsInOrderListPage) {this.util.checkHideFooter(this.order.detail.length, '')}
                else if (data['directionY'] == "up") { this.util.checkHideFooter(10, data['directionY']) }
                this.direction = data['directionY'];
            }
            this.changeDetectorRef.detectChanges();
        });
    }

    Proceed() {
        if (this.hasOrderListError) {
            return;
        }
        if (this.isModal) {
            let orderReviewModal = this.modalCtrl.create('OrderReview', { isModal: true, order: this.order }, { enableBackdropDismiss: false });
            orderReviewModal.present();
            orderReviewModal.onDidDismiss((action) => {
                if (action) {
                    this.viewCtrl.dismiss();
                }
            })
        } else {
            if ((this.order.detail[0].line_type.sales_ind == 0 || this.order.detail[0].line_type.sales_ind == 2) && this.storageService.getSalesIndFromOrder(this.order) !== SalesInd.FOC) {
                this.util.displayAlert(this.alertCtrl, "Unable to Proceed", "First record is not allowed for Free Goods/Rebate items.");
                return;
            }
            let checkProductZeroPrice = this.order.detail.filter(x => x.gross_amt === 0 && x.line_type?.ind == "S");
            
            // MOV confirmation
            // HK case
            // TODO: HK not done
            if (this.userService.isHKSurchargeApplicable()) {
                let arrButtons = [
                    { text: 'Add More Items', handler: () => { return; } },
                    { text: 'Proceed', handler: 
                        () => { 
                            if (this.storageService.getSalesIndFromOrder(this.order) == 'F') {
                                this.navigateToOrderReview();
                            } else {
                                this.checkOrderSimulatedBeforeNavigate();
                            } 
                        }
                    }
                ];

                this.util.displayConfirmation(this.alertCtrl, this.customerMOVSurcharge.HeaderMessage, this.customerMOVSurcharge.DetailMessage, arrButtons);
            // TW case
            } else if (this.storageService.getSettingId() == SettingId.TW && checkProductZeroPrice.length > 0) {
                let OrderStatusListModal = this.modalCtrl.create('OrderListZeroPricePopover',
                    { order: this.order, salesInd: this.storageService.getSalesIndFromOrder(this.order) },
                    { enableBackdropDismiss: false },
                );
                OrderStatusListModal.present();
                OrderStatusListModal.onDidDismiss((data) => {
                    if (data.action === ModalAction.Proceed) {
                        const removedCount = this.order.detail.length - data.order.detail.length;
                        this.order = data.order;
                        for (let i = 0; i < removedCount; i++) {
                            this.badgeService.decreaseBadge();
                        }

                        this.storageService.setOrder(this.order).then(() => {
                            if (this.order.detail.length === 0) {
                                this.navCtrl.parent.select(Page.ProductList);
                                return;
                            }

                            if ((this.order.detail[0].line_type.sales_ind == 0 || this.order.detail[0].line_type.sales_ind == 2) && this.storageService.getSalesIndFromOrder(this.order) != 'F') {
                                this.util.displayAlert(this.alertCtrl, "Unable to Proceed", "First record is not allowed for Free Goods/Rebate items.");
                                return;
                            }

                            if (this.storageService.getSalesIndFromOrder(this.order) == 'F') {
                                this.navigateToOrderReview();
                            } else {
                                this.checkOrderSimulatedBeforeNavigate();
                            }
                        });
                    }
                });
            // Other
            } else {
                if(this.storageService.getSalesIndFromOrder(this.order) == 'F') {
                    this.navigateToOrderReview();
                } else {
                    this.checkOrderSimulatedBeforeNavigate();
                } 
            }
        }
    }

    viewStockLevel(item: OrderDetailModel) {
        if (!this.isModal) {
            let salesorg = this.order.salesorg;
            let distChannel = this.order.distchannel;
            let stockLevelModal = this.modalCtrl.create('StockLevel', { data: item, salesorg: salesorg, distChannel: distChannel }, { enableBackdropDismiss: false });

            stockLevelModal.present();
        } else {
            this.util.displayToast(this.toastCtrl, "Not available to view");
        }
    }
    SelectSLOC(item: OrderDetailModel) {
        if (!this.isModal) {
            let SLOCModal = this.modalCtrl.create('SlocSelection', { data: item }, { enableBackdropDismiss: false });
            SLOCModal.present();
            SLOCModal.onDidDismiss((data) => {
                if (!!data) {
                    if (!!data.action) {
                        switch (data.action) {
                            case 'cancel':
                                return false;
                            case 'proceed':
                                item.batch_no = data.selectedBatchNo;
                                item.batch_exp_date = data.selectedBatchEx;
                                item.sloc_code = data.selectedSloc;
                                this.storageService.setOrder(this.order);
                                return;
                        }
                    }  
                } 
            })
        } else {
            this.util.displayToast(this.toastCtrl, "Not available to view");
        }
    }

    viewConditionTypeDtl(order: OrderDetailModel) {
        let condTypeModal = this.modalCtrl.create('ConditionType', { selectedCustomer: this.selectedCustomer, orderItem: order, isModal: this.isModal }, { enableBackdropDismiss: false });
        condTypeModal.present();

        condTypeModal.onDidDismiss((data) => {
            if (data.action == 's') {

                this.loading = this.util.displayLoading(this.loading, this.loadingCtrl, "Saving");
                this.order.is_manual_price_deleted= data.is_manual_price_deleted
                this.storageService.setOrder(this.order).then(() => {
                    // this.getTotal();
                    this.loading.dismiss();
                    this.updateOrderList();
                   
                });
            }
        });
    }

    createNewOrder() {
        this.storage.get("orderReason").then((v) => {
            this.selectedCustomer.order_reason = v ? v : "";
            this.order = this.util.createNewOrder(this.selectedCustomer, this.storageService.getSalesrepCode(), this.storageService.getOrderType(this.storageService.getSalesInd()));
            this.storageService.setOrder(this.order)
        });
    }

    gotoPrevTab() {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.ProductList);
    }
    gotoNextTab() {
        this.util.changeTab(this.loading, this.loadingCtrl, this.navCtrl, Page.TransactionHistList);
    }

    viewPopover(myEvent, order: OrderDetailModel, index: number) {
        let salesPrdList = this.order.detail.filter((r) => { return r.line_type.sales_ind == 1 }); //{ return r.line_type.sales_ind !== 0 });
        if (salesPrdList) {
            this.highLevelList.length = 0;
            salesPrdList.forEach((item) => {
                let highLevel = new OrderHighLevelModel();
                highLevel.prd_code = item.prd_code;
                highLevel.prd_name = item.prd_name;
                highLevel.so_item = item.so_item;
                this.highLevelList.push(highLevel);
            });
            if (order.line_type.sales_ind == 0) {
                if (!order.high_level.so_item) {
                    let s = this.highLevelList.find((r) => { return r.prd_code == order.high_level.prd_code; });
                    if (s) {
                        order.high_level.so_item = s.so_item;
                    }
                }
            };
        }
        if(this.storageService.getSettingId() == "1007") {
            order.ttl_disc_amt = Number(this.getItemDiscount(order, this.storageService.getCurrency()));
        }
        let popover = this.popoverCtrl.create('OrderListPopover',
            {
                order: order, salesInd: this.storageService.getSalesIndFromOrder(this.order),
                isModal: this.isModal, index: index, highLevelList: this.highLevelList
            });
        popover.present({
            ev: myEvent
        });

        popover.onDidDismiss(() => {
            this.storageService.setOrder(this.order);
        });
    }

    scrollToTop() {
        this.content.scrollToTop();
    }

    getItemDiscount(orderDetail: OrderDetailModel, type: string) {
        let orderDiscList = orderDetail.cond_type;
        let value: string = ".00";
        // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
        let totalAmount: number = 0;
        if (orderDiscList.length > 0) {
            let arr = orderDiscList.filter((r) => {
                // return r.disc_type_code == type &&
                //     r.disc_cond != "ZTS0" &&
                //     r.disc_cond != "ZTS5" &&
                //     r.disc_cond != "ZTN7" &&
                //     r.disc_cond != "MWST" &&
                //     r.disc_cond != "ZSS0" &&
                //     r.disc_cond != "ZSS1" &&
                //     r.disc_cond != "ZSS2" &&
                //     r.disc_cond != "ZSS3" &&
                //     r.disc_cond != "ZMS0" &&
                //     r.disc_cond != "ZGS0"
                // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
                // % ZWN0 $ZWR0
                if(this.storageService.getSettingId() == "1007") {
                    if(r.disc_cond == 'ZWR0' || r.disc_cond == 'ZWN0'){
                        return r.disc_type_code == type
                    }
                }else{
                    return r.disc_type_code == type && this.storageService.getConditionTypeList().indexOf(r.disc_cond) == -1 && this.storageService.getConditionTypeTax().indexOf(r.disc_cond) == -1
                }
                
            })
            if (arr.length > 0) {
               // STRY0019308 TW Easy Order UAT feedback - Part 1 - pricing
                // for ZWR0 fetch from the disc_value
                arr.forEach((item) => {
                    if(this.storageService.getSettingId() == "1007" && item.disc_cond == 'ZWR0') {
                        totalAmount += Number(item.disc_value.toString().includes('-') ? this.isModal ? item.disc_amount : (Number(item.disc_amount)/1000)*orderDetail.quantity : this.isModal ? item.plusminus + item.disc_amount : item.plusminus + (Number(item.disc_amount)/1000)*orderDetail.quantity );
                    }else{
                        totalAmount += Number(item.plusminus + (this.isModal ? item.ori_disc_amount : item.disc_amount));
                    }
                    
                });
                if (totalAmount != 0) {
                    value = totalAmount.toFixed(2).toString();
                }
            }else{
                value = totalAmount.toFixed(2).toString()
            }
        }
        return value;
    }

    removeItems(soItem: string, index: any) {
        //Remove index[j] from array & refresh
        let arrButtons = [{ text: 'No', handler: () => {} },
        {
            text: 'Yes', handler: () => {
                this.order.detail.splice(index, 1);
                this.badgeService.decreaseBadge();
                this.storageService.setOrder(this.order).then(() => {
                    if (this.order.detail.length == 0) {
                        this.navCtrl.parent.select(Page.ProductList);
                        return;
                    };
                    this.updateHighLevel(soItem);
                    this.isHandlingFOC = true;
                    this.updateOrderList();
                })
            }
        }];
        this.util.displayConfirmation(this.alertCtrl, "Delete item", "Are you sure you want to delete the following item?", arrButtons);
    }

    removeFOC(item: OrderDetailModel) {
        if (!this.isModal) {
            let arrButtons = [{ text: 'No', handler: () => {} },
            {
                text: 'Yes', handler: () => {
                    item.foc_del_ind = 1;
                    this.storageService.setOrder(this.order).then(() => {
                        this.getTotal();
                    })
                }
            }];
            this.util.displayConfirmation(this.alertCtrl, "Delete FOC item", "Are you sure you want to delete the following item?", arrButtons);
        }
    }

    undoRemoveFOC(item: OrderDetailModel) {
        if (!this.isModal) {
            let arrButtons = [
                { text: 'No', handler: () => {} },
                {
                    text: 'Yes', handler: () => {
                        item.foc_del_ind = 0;
                        this.storageService.setOrder(this.order).then(() => {
                            this.getTotal();
                        })
                    }
                }];
            this.util.displayConfirmation(this.alertCtrl, "Undo Deletion", "Are you sure you want to enable the following item?", arrButtons);
        }
    }

    editFOC() {
        let etFOCModal = this.modalCtrl.create('ETFOC', { etFoc: this.order.et_foc }, { enableBackdropDismiss: false });
        etFOCModal.present();
        etFOCModal.onDidDismiss((data) => {
            if (data.action === ModalAction.Save) {
                this.order.et_foc = data.etFoc;
                this.storageService.setOrder(this.order).then(() => {
                    this.storageService.setSimulatedOrder(this.order).then(() => {
                        this.isHandlingFOC = false;
                        this.updateOrderList();
                    });
                });
            }
        });
    }

    // searchProduct(packageBomUID: string, lastIndexOfBomPackage: number) {
    //     let lstBomProduct: BomProductModel[] = [];
    //     let lstBomProductToBeAdded: BomProductModel[] = [];
    //     let tempLstPrd = this.order.detail.filter(r => r.packageBomUID === packageBomUID);
    //     tempLstPrd.forEach((item, index) => {
    //         let bom = new BomProductModel();
    //         bom.isParent = item.isParentBom;
    //         bom.prd_code = item.prd_code;
    //         lstBomProduct.push(bom);
    //     });

    //     let lineType = tempLstPrd.filter(r => r.isParentBom === true)[0].line_type

    //     let bomModal = this.modalCtrl.create('BomProductSearchPage', { lstBomProduct: lstBomProduct }, { enableBackdropDismiss: false, cssClass: 'page-bom-product-selection' });
    //     bomModal.present();
    //     bomModal.onDidDismiss((data) => {
    //         if (!!data) {
    //             if (!!data.action) {
    //                 switch (data.action) {
    //                     case ModalAction.Cancel:
    //                     return false;
    //                     case ModalAction.Proceed:
    //                     let parentQuantity = lstBomProduct.filter(ele => ele.isParent == true)[0].quantity;
    //                     data.lstProductToBeAddedToBomPackage.forEach((element: ChildrenBomProductModel) => {
    //                         let newBomProduct: BomProductModel =  {
    //                         prd_code: element.prd_code,
    //                         prd_name: element.prd_name,
    //                         uom: element.uom,
    //                         price: element.price,
    //                         tax: element.tax,
    //                         stock_amount: element.stock_amount,
    //                         item_cat_grp: element.item_cat_grp,
    //                         bonus: element.bonus,
    //                         quantity: 1 * parentQuantity,
    //                         default_quantity: 1,
    //                         isParent: false,
    //                         line_type: lineType,
    //                         line_type_list: []
    //                         };
        
    //                         lstBomProductToBeAdded.push(newBomProduct);
    //                         this.addBomnToOrder(lstBomProductToBeAdded, packageBomUID ,lastIndexOfBomPackage);
    //                     });
    //                     return;
    //                 }
    //             }  
    //         } 
    //     });
    // }

    /**
     * Create / edit order 
     * @param lstBomProduct BomProductModel
     */
    // private addBomnToOrder(lstBomProduct: BomProductModel[], packageBomUID: string , lastIndexOfBomPackage: number) {
    //     this.customerService.validateSelectedCustomer(this.storageService.getToken()
    //     , this.selectedCustomer.cust_code
    //     , this.storageService.getSalesInd()
    //     , this.selectedCustomer.order_reason
    //     , this.storageService.getSalesrepCode()
    //     , this.storageService.getSettingId())
    //     .subscribe(
    //         (data) => {
    //             if (data.length > 0) {
    //                 let arrPrdWithQty: ProductModel[] = [];
    //                 lstBomProduct.forEach((item, index) =>{
    //                     if (item.quantity > 0) {
    //                         let product: ProductModel = {
    //                             prd_grp_code: '',
    //                             prd_grp_name: '',
    //                             uom_list: [],
    //                             must_sell: undefined,
    //                             line_type: item.line_type,
    //                             line_type_list: [],
    //                             item_cat_grp: item.item_cat_grp,
    //                             base_uom: item.uom,
    //                             prd_code: item.prd_code,
    //                             prd_name: item.prd_name,
    //                             uom: item.uom,
    //                             price: item.price,
    //                             quantity: item.quantity,
    //                             stock_amount: item.stock_amount,
    //                             bonus: item.bonus,
    //                             tax: item.tax,
    //                             line_type_code: '', //item.line_type_code,
    //                             total: 0,
    //                             prd_type: ProductType.NORMAL,
    //                         }
    //                         arrPrdWithQty.push(product);
    //                     }
    //                 });

    //                 if (arrPrdWithQty.length > 0) {
    //                     this.insertBomIntoOrderDetail(arrPrdWithQty, packageBomUID, lastIndexOfBomPackage);
    //                     this.util.displayToast(this.toastCtrl, 'Bom package has been updated.');
    //                 };
    //             } else {
    //                 this.storageService.setSalesInd("");
    //                 this.storage.remove('selectedCustomer');
    //                 this.storageService.clearCustomer();
    //                 this.badgeService.resetBadge();
    //                 this.storageService.clearOrder();
    //                 this.util.displayAlertWithRedirectPage(this.alertCtrl, this.navCtrl, Errors.CustomerInvalid.Code, "Customer selected does not belongs to this order type!", Page.CustomerList);
    //                 return;
    //             }
    //         }
    //     );
    // }

    /**
     * Insert a bom package into order detail
     * @param prd ProductModel
     */
    // private insertBomIntoOrderDetail(lstPrd: ProductModel[], packageBomUID: string, lastIndexOfBomPackage: number) {
    //     let indexToBeUpdated = lastIndexOfBomPackage + lstPrd.length;
    //     lstPrd.forEach((prd, index) => {
    //         let oDtl = new OrderDetailModel();
    //         oDtl.prd_code = prd.prd_code;
    //         oDtl.prd_name = prd.prd_name;
    
    //         oDtl.gross_amt = prd.price;
    //         // oDtl.net_amount = prd.price;
    //         // oDtl.discount_amount = 0;
    //         // oDtl.tax_amount = 0;
    
    //         oDtl.ttl_net_amt = prd.price * prd.quantity;
    //         oDtl.ttl_gross_amt = prd.price * prd.quantity;
    //         oDtl.ttl_disc_amt = 0;
    //         oDtl.ttl_tax_amt = 0;
    
    //         oDtl.quantity = prd.quantity;
    //         oDtl.default_quantity = prd.quantity;
    //         oDtl.uom_code = prd.uom;
    //         oDtl.bonus = prd.bonus;
    //         oDtl.stock_amount = prd.stock_amount.toString();
    //         oDtl.line_type = prd.line_type;
    //         oDtl.item_category = this.util.generateItemCategoryForBomProduct(prd.prd_type === ProductType.BOM ? true: false, this.storageService.getSettingId());
    
    //         let highLevel = new OrderHighLevelModel();
    //         if (prd.line_type.sales_ind == 0) {
    //             let salesPrdList = this.order.detail.filter((r) => { return r.line_type.sales_ind == 1; });
    //             if (salesPrdList.length > 0) {
    //                 highLevel.prd_code = salesPrdList[salesPrdList.length - 1].prd_code;
    //                 highLevel.prd_name = salesPrdList[salesPrdList.length - 1].prd_name;
    //                 highLevel.so_item = salesPrdList[salesPrdList.length - 1].so_item;
    //                 if (!(Number(highLevel.so_item) > 0)) {
    //                     let index = this.order.detail.findIndex((r) => { return r.prd_code == highLevel.prd_code && r.line_type.sales_ind == 1 });
    //                     if (index > -1)
    //                         highLevel.so_item = (index + 1).toString();
    //                 }
    //             }
    //         }
    //         oDtl.high_level = highLevel;
    //         oDtl.base_uom = prd.base_uom; // Base uom CCLIORDER-1876
    
    //         // prd_type
    //         oDtl.prd_type = prd.prd_type;
    //         oDtl.isParentBom = prd.prd_type === ProductType.BOM ? true : false;
    //         oDtl.isChildBom = prd.prd_type === ProductType.BOM ? false : true;
    //         oDtl.packageBomUID = packageBomUID
    //         oDtl.lastIndexOfBomPackage = indexToBeUpdated;
    
    //         this.order.detail.splice((lastIndexOfBomPackage + 1), 0, oDtl);
    //         this.badgeService.incrementBadge();

    //         lastIndexOfBomPackage++;
    //     });

    //     this.order.detail.forEach((item, index) => {
    //         if (item.packageBomUID === packageBomUID) {
    //             item.lastIndexOfBomPackage = indexToBeUpdated;
    //         }
    //     });

    //     this.updateOrderList();
    // }

    isBomAvailable() {
        if (this.storageService.getSettingId() === SettingId.TH || this.storageService.getSettingId() === SettingId.SG) {
            if (this.storageService.getSetupValue(this.setups.AllowBom.ID) === '1') {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    checkProductType(item: OrderDetailModel) {
        if (item.item_category === 'ZTAI' || item.item_category === 'ZTAQ') {
            return this.ProductTypeEnum.BOM;
        } else {
            return this.ProductTypeEnum.NORMAL;
        }
    }

    toggleBomDetail(item: OrderDetailModel) {
        item.display_bom_detail = !item.display_bom_detail
    }

    decreaseBomQty(orderDetailItem: OrderDetailModel) {
        if (orderDetailItem.quantity == null || orderDetailItem.quantity == undefined) {
            orderDetailItem.quantity = 0;
            return;
        }

        if (orderDetailItem.quantity == 0) {
            orderDetailItem.quantity = 0;
            return;
        }

        orderDetailItem.quantity--;
        let tmp: number = _.clone(orderDetailItem.quantity);

        for (let index = 0; index < orderDetailItem.bom_item.length; index++) {
            orderDetailItem.bom_item[index].quantity = (orderDetailItem.bom_item[index].quantity_ratio * tmp);
        }

        // Parent price
        this.priceCalculation(orderDetailItem);
        // Children price
        orderDetailItem.bom_item.forEach((r) => {
            this.priceCalculation(r);
        });

        this.storageService.setOrder(this.order);
        this.getTotal();
      }
    
    increaseBomQty(orderDetailItem: OrderDetailModel) {
        if (orderDetailItem.quantity == null || orderDetailItem.quantity == undefined) {
            orderDetailItem.quantity = 0;
            return;
        }

        orderDetailItem.quantity++;
        let tmp: number = _.clone(orderDetailItem.quantity);

        for (let index = 0; index < orderDetailItem.bom_item.length; index++) {
            orderDetailItem.bom_item[index].quantity = (orderDetailItem.bom_item[index].quantity_ratio * tmp);
        }

        // Parent price
        this.priceCalculation(orderDetailItem);
        // Children price
        orderDetailItem.bom_item.forEach((r) => {
            this.priceCalculation(r);
        });

        this.storageService.setOrder(this.order);
        this.getTotal();
    }

    updateBomQty(ev: any, orderDetailItem: OrderDetailModel) {
        if (orderDetailItem.quantity == null || orderDetailItem.quantity == undefined) {
            orderDetailItem.quantity = 0;
        }

        if (orderDetailItem.quantity <= 0) {
            orderDetailItem.quantity = 0;
        }

        let tmp: number = _.clone(orderDetailItem.quantity);

        for (let index = 0; index < orderDetailItem.bom_item.length; index++) {
            orderDetailItem.bom_item[index].quantity = (orderDetailItem.bom_item[index].quantity_ratio * tmp);
        }

        // Parent price
        this.priceCalculation(orderDetailItem);
        // Children price

        orderDetailItem.bom_item.forEach((r) => {
            this.priceCalculation(r);
        });

        this.storageService.setOrder(this.order);
        this.getTotal();
    }

    /**
     * Price calculation
     */
    private priceCalculation(orderDetailItem: OrderDetailModel) {
        orderDetailItem.ttl_disc_amt = 0;
        orderDetailItem.ttl_net_amt = 0;
        orderDetailItem.ttl_tax_amt = 0;
        orderDetailItem.ttl_gross_amt = orderDetailItem.gross_amt * orderDetailItem.quantity;
        let taxPercent: number = 0;

        if (orderDetailItem.cond_type.length > 0) {
            orderDetailItem.cond_type.forEach((item) => {
                if (this.storageService.getConditionTypeList().indexOf(item.disc_cond) === -1 && item.disc_cond != this.storageService.getConditionTypeTax().toString()) {
                    if (item.disc_type_code === '%') {
                        orderDetailItem.ttl_disc_amt += Number(item.plusminus + (orderDetailItem.ttl_gross_amt * Number(item.disc_amount) / 100));
                    } else {
                        orderDetailItem.ttl_disc_amt += Number(item.plusminus + (Number(item.disc_amount) * orderDetailItem.quantity)); 
                    }
                } else if (item.disc_cond === this.storageService.getConditionTypeTax().toString()) {
                    taxPercent = Number(item.disc_amount);
                }
            });
        }

        orderDetailItem.ttl_net_amt = orderDetailItem.ttl_gross_amt + orderDetailItem.ttl_disc_amt;
        if (taxPercent > 0) {
            orderDetailItem.ttl_tax_amt = orderDetailItem.ttl_net_amt * (Number(taxPercent) / 100);
        }
        
        orderDetailItem.default_quantity = orderDetailItem.quantity;
    }

    private markOrderListError() {
        this.hasOrderListError = true;
        this.storageService.clearSimulatedOrder();
    } 
}



// WEBPACK FOOTER //
// ./src/pages/order-list/order-list.ts